import { Moon, Trash2 } from "lucide-react"; // Optional: for icons

export default function Settings() {
  return (
    <div className="bg-gray-50 min-h-screen p-6">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-2xl font-semibold text-gray-900 mb-6">Settings</h1>

        <div className="bg-white shadow-sm border border-gray-200 rounded-lg divide-y divide-gray-200">
          {/* Appearance */}
          <div className="flex items-center justify-between p-4">
            <div>
              <h2 className="font-medium text-gray-800">Appearance</h2>
              <p className="text-sm text-gray-500">Customize how the app looks and feels</p>
            </div>
            <button className="flex items-center gap-1 border border-gray-300 rounded-md px-3 py-1 text-sm hover:bg-gray-100 transition">
              <Moon className="w-4 h-4" />
              Dark Mode
            </button>
          </div>

          {/* Delete Account */}
          <div className="flex items-center justify-between p-4">
            <div>
              <h2 className="font-medium text-gray-800">Delete Account</h2>
              <p className="text-sm text-gray-500">
                Permanently delete your account and all associated data
              </p>
            </div>
            <button className="flex items-center gap-1 text-sm text-red-600 hover:underline">
              <Trash2 className="w-4 h-4" />
              Delete Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
